<template>
  <div class="plan">
    <baxiaozhongte :data="data.baxiaozhongte" v-if="data?.baxiaozhongte" />
    <shuangbozhongte :data="data.shuangbozhongte" v-if="data?.shuangbozhongte" />
    <niubishuangbo :data="data.niubishuangbo" v-if="data?.niubishuangbo" />
    <liuweibizhong :data="data.liuweibizhong" v-if="data?.liuweibizhong" />
    <jihuapingteyixiao
      :data="data.jihuapingteyixiao"
      v-if="data?.jihuapingteyixiao"
    />
    <tehaodabaowei :data="data.tehaodabaowei" v-if="data?.tehaodabaowei" />
    <pingteyiwei111 :data="data.pingteyiwei111" v-if="data?.pingteyiwei111" />
    <jiaqinyeshou :data="data.jiaqinyeshou" v-if="data?.jiaqinyeshou" />
    <chengyupingte :data="data.chengyupingte" v-if="data?.chengyupingte" />
    <fengyuleidian :data="data.fengyuleidian" v-if="data?.fengyuleidian" />
    <shimafangwuma :data="data.shimafangwuma" v-if="data?.shimafangwuma" />
    <shibamabizhong :data="data.shibamabizhong" v-if="data?.shibamabizhong" />
    <liuxiao :data="data.liuXiao" v-if="data?.liuXiao" />
    <wuXingZhongTe :data="data.wuXingZhongTe" v-if="data?.wuXingZhongTe" />
    <daxiao :data="data.daXiaoShu" v-if="data?.daXiaoShu" />
    <sanxiao :data="data.sanXiao" v-if="data?.sanXiao" />
    <code24 :data="data.code24" v-if="data?.code24" />
    <tou :data="data.tou" v-if="data?.tou" />
    <wei :data="data.wei" v-if="data?.wei" />
    <yixiao :data="data.yiXiao" v-if="data?.yiXiao" />
    <danshuang :data="data.danShuang" v-if="data?.danShuang" />
  </div>
</template>

<script setup>
import { myHttp } from "@/request/index.js";
import { ref } from "vue";
import liuxiao from "./liuxiao.vue";
import niubishuangbo from "./niubishuangbo.vue";
import danshuang from "./danshuang.vue";
import tou from "./tou.vue";
import wei from "./wei.vue";
import yixiao from "./yixiao.vue";
import code24 from "./code24.vue";
import sanxiao from "./sanxiao.vue";
import daxiao from "./daxiao.vue";
import wuXingZhongTe from "./wuXingZhongTe.vue";
import pingteyiwei111 from "./pingteyiwei111.vue";
import shimafangwuma from "./shimafangwuma.vue";
import fengyuleidian from "./fengyuleidian.vue";
import shibamabizhong from "./shibamabizhong.vue";
import jiaqinyeshou from "./jiaqinyeshou.vue";
import chengyupingte from "./chengyupingte.vue";
import jihuapingteyixiao from "./jihuapingteyixiao.vue";
import liuweibizhong from "./liuweibizhong.vue";
import baxiaozhongte from "./baxiaozhongte.vue";
import shuangbozhongte from "./shuangbozhongte.vue";
import tehaodabaowei from "./tehaodabaowei.vue";

const data = ref(null);

function loadData() {
  myHttp.get("/api/information/queryAll_6").then((res) => {
    if (res.success) {
      data.value = res.data;
      console.log(res.data, "plan");
    }
  });
}

loadData();
</script>

<style lang="scss" scoped>
::v-deep .plan_item {
  border-radius: 12px;
  overflow: hidden;
  border: 3px solid #4292ef;
  margin-bottom: 16px;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    font-weight: bold;
    text-align: center;
    background-image: linear-gradient(to bottom, #509af2, #f1edeb);
    padding: 3px 0;
    font-size: 28px;
    color: #fff !important;
    // border-top: 2px solid #767474;
    // border-bottom: 2px solid #767474;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .name {
    color: #0000ff !important;
  }
  ul {
    background-color: #eee;
    li {
      text-align: center;
      padding: 0px 12px !important;
      font-weight: bold;
      display: flex;
      line-height: 35px;
      justify-content: center;
      >div{
        flex: 1;
      }
      .value {
        color: red;
        .win {
          background-color: #ffff00;
        }
      }
      &:not(:last-child) {
        border-bottom: 2px solid #d2d2d2;
      }
      .yuce {
        display: flex;
        flex: 1;
        justify-content: center;
        border-right: 2px solid #ccc;
      }
      .qi {
        width: 15%;
        border-right: 2px solid #ccc;
        padding-right: 6px;
      }
      .winText {
        width: 25%;
        border-left: 1px solid #ccc;
        padding-left: 6px;
      }
      .suck {
        text-decoration-line: none;
      }
    }
  }
}
.plan {
  .title {
    text-align: center;
    background-color: #4292ef;
    font-size: 25px;
    font-weight: bold;
    padding: 6px 0;
  }
}
</style>